"use client";

// Platform observability wrapper — render <Observability /> in app/layout.tsx.
// Reads configuration from NEXT_PUBLIC_* env vars (see .env.example).
// Platform-managed: seeded by github-infra/modules/juiceco-repo.
//
// IMPORTANT: This is an explicit functional-component wrapper, NOT a pure
// re-export. Next.js 15+ will tree-shake pure re-export "use client"
// components whose exported function returns null, breaking the
// ObservabilityProvider useEffect that bootstraps CloudWatch RUM. The
// wrapper preserves the side-effect contract.
import {
  ObservabilityProvider,
  type ObservabilityProviderProps,
} from "@juiceco-io/observability-sdk/react";

export type { ObservabilityProviderProps };

export default function Observability(
  props: Partial<ObservabilityProviderProps> = {},
) {
  const app = props.app ?? process.env.NEXT_PUBLIC_APP_NAME;
  const env = props.env ?? process.env.NEXT_PUBLIC_ENV;
  const version = props.version ?? process.env.NEXT_PUBLIC_APP_VERSION;
  const service = props.service ?? "web";

  if (!app || !env || !version) {
    if (typeof console !== "undefined") {
      console.warn(
        "[Observability] Missing required tags — skipping " +
          "ObservabilityProvider mount. Pass `app`/`env`/`version` as " +
          "props or set NEXT_PUBLIC_APP_NAME, NEXT_PUBLIC_ENV, and " +
          "NEXT_PUBLIC_APP_VERSION in the build environment.",
      );
    }
    return null;
  }

  return (
    <ObservabilityProvider
      app={app}
      env={env}
      version={version}
      service={service}
      rum={props.rum}
    />
  );
}
